import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiService } from "./dal/api.service";
import { DocumentService } from "./document/document.service";
import { ErrorHandlerService } from "./error-handler/error-handler.service";
import { DialogWrapperService } from "../../../src/app/services/dialog/dialog-wrapper.service";
import { environment } from "../../../src/environments/environment";
@Injectable({
  providedIn: "root",
})
export class CyberArkService extends ApiService {
    private url =
    "api/CyberArkKeyVault/GetCyberArkKeyValue?key=" + environment.googleApiKey;
  constructor(
    httpClient: HttpClient,
    errorHandlerService: ErrorHandlerService,
    dialog: DialogWrapperService,
    public documentService: DocumentService
  ) {
    super(httpClient, errorHandlerService, dialog);
  }

 public getCyberArkKeyvalue() {
    return this.httpClient.get<any>(
      environment.serviceBase +
        this.url
    );
  }
}
